import React, { useState, useEffect } from "react";
import "../EmployeeSection/employeewalletamount.css";
import { Button, Form, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Breadcrumbs } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import axios from "axios";
import Base from "../admin_components/Admin_Base";
import { ADMIN_API_BASE_URL } from "../Auth/Api";

const Employeewalletamount = () => {
  const [employeeList, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterName, setFilterName] = useState("All"); // Name filter state
  const [editMode, setEditMode] = useState(null);
  const [editedEmployee, setEditedEmployee] = useState({});
  const itemsPerPage = 33;

  useEffect(() => {
    fetchEmployeewalletamount();
  }, []);

  const fetchEmployeewalletamount = async () => {
    try {
      const response = await axios
        .get
        // Add your API
        (`${ADMIN_API_BASE_URL}/main/admin/employee-incentive-amount`);
      setList(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const filteredEmployees = employeeList.filter(
    (emp) =>
      (filterStatus === "All" || emp.status === filterStatus) &&
      (filterName === "All" ||
        emp.fullName.toLowerCase().includes(filterName.toLowerCase()))
  );

  const paginatedEmployees = filteredEmployees.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

  const handleDownloadExcel = () => {
    const filteredData = filteredEmployees.map(
      ({
        employeeReferenceId,
        fullName,
        incentiveamountrecevied,
        withdrawamount,
        outstandingamount,
      }) => ({
        "Employee ID": employeeReferenceId,
        "Employee Name": fullName,
        "Incentive Amount Recevied": incentiveamountrecevied,
        "withdraw Amount": withdrawamount,
        "Outstanding Amount": outstandingamount,
      })
    );

    if (filteredData.length === 0) {
      Swal.fire(
        "No data to export!",
        "Please apply a filter that includes results.",
        "warning"
      );
      return;
    }

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Filtered_Employees");
    XLSX.writeFile(wb, "Filtered_Employee_List.xlsx");
  };

  const handleEdit = (employee) => {
    setEditMode(employee.id);
    setEditedEmployee({ ...employee });
  };

  const handleSave = async (id) => {
    try {
      await axios.put(
        // Add your API
        editedEmployee
      );
      setList((prevList) =>
        prevList.map((employee) =>
          employee.id === id ? { ...editedEmployee } : employee
        )
      );
      setEditMode(null);
    } catch (error) {
      console.error("Error updating employee:", error);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      try {
        await axios
          .delete
          // Add your API
          ();
        setList(employeeList.filter((employee) => employee.id !== id));
      } catch (error) {
        console.error("Error deleting employee:", error);
      }
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await axios.put(
        // Add your API
        { status: newStatus }
      );
      setList((prevList) =>
        prevList.map((employee) =>
          employee.id === id ? { ...employee, status: newStatus } : employee
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleChange = (e, field) => {
    setEditedEmployee({ ...editedEmployee, [field]: e.target.value });
  };

  const handleCancel = () => {
    setEditMode(null);
    setEditedEmployee({});
  };

  return (
    <Base>
      <div
        className="pt-3 mt-5 res_container"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
        }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          className="admin_navigation"
        >
          <Link
            underline="hover"
            key="1"
            color="inherit"
            href="/admin/dashboard"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="none"
            key="2"
            color="inherit"
            href="/admin/admin_add_employee"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Employee Wallet Amount
          </Link>
        </Breadcrumbs>
      </div>

      <h2 className="text-center fw-bold main_heading">
        {" "}
        Employee Wallet Amount
      </h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <div
          className="emp_filters"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "95%",
          }}
        >
          {/* <Form.Select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="filter-dropdown"
          >
            <option value="All">All Employees</option>
            <option value="Active">Active Employees</option>
            <option value="Inactive">Inactive Employees</option>
          </Form.Select> */}

          {/* Name Filter Input */}
          <Form.Control
            type="text"
            placeholder="Search by name"
            value={filterName === "All" ? "" : filterName}
            onChange={(e) =>
              setFilterName(e.target.value === "" ? "All" : e.target.value)
            }
            className="filter-dropdown"
          />

          <Button className="csv_listemp_button" onClick={handleDownloadExcel}>
            Download Excel
          </Button>
        </div>
      </div>

      <Table className="customer-table">
        <thead>
          <tr>
            <th>Sno</th>
            <th>Employee ID</th>
            <th>Employee Name</th>
            <th>Total Incentive Amount Received</th>
            <th>Withdraw Amount</th>
            <th>Outstanding Amount</th>
          </tr>
        </thead>
        <tbody>
          {paginatedEmployees.map((employee, index) => (
            <tr key={employee.id}>
              <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
              <td>{employee.employeeReferenceId}</td>

              <td>
                {editMode === employee.id ? (
                  <Form.Control
                    type="text"
                    value={editedEmployee.fullName}
                    onChange={(e) => handleChange(e, "fullName")}
                  />
                ) : (
                  employee.fullName
                )}
              </td>

              <td>
                {editMode === employee.id ? (
                  <Form.Control
                    type="text"
                    value={editedEmployee.designation}
                    onChange={(e) => handleChange(e, "designation")}
                  />
                ) : (
                  employee.designation
                )}
              </td>

              <td>
                {editMode === employee.id ? (
                  <Form.Control
                    type="text"
                    value={editedEmployee.mobile}
                    onChange={(e) => handleChange(e, "mobile")}
                  />
                ) : (
                  employee.mobile
                )}
              </td>

              {/*            
              <td>
                {editMode === employee.id ? (
                  <Form.Select
                    value={editedEmployee.status}
                    onChange={(e) => handleChange(e, "status")}
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                ) : (
                  <Form.Select
                    value={employee.status}
                    onChange={(e) =>
                      handleStatusChange(employee.id, e.target.value)
                    }
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                )}
              </td> */}

              <td>
                {editMode === employee.id ? (
                  <div className="d-flex">
                    <Button
                      onClick={() => handleSave(employee.id)}
                      className="btn-success mx-1"
                    >
                      Save
                    </Button>
                    <Button onClick={handleCancel} className="btn-danger mx-1">
                      Cancel
                    </Button>
                  </div>
                ) : (
                  <>
                    <Button
                      onClick={() => handleEdit(employee)}
                      className="btn-primary mx-1"
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => handleDelete(employee.id)}
                      className="btn-danger mx-1"
                    >
                      Delete
                    </Button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="pagination-controls">
        <Button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          Previous
        </Button>
        <span>
          {" "}
          Page {currentPage} of {totalPages}{" "}
        </span>
        <Button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage(currentPage + 1)}
        >
          Next
        </Button>
      </div>
    </Base>
  );
};

export default Employeewalletamount;
